"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AttackAndDef;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _classnames = _interopRequireDefault(require("classnames"));

var _CharacterStatsWindowModule = _interopRequireDefault(require("../../CharacterStatsWindow.module.scss"));

var _CharacterStatsWindow = _interopRequireDefault(require("../../CharacterStatsWindow.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AttackAndDef(_ref) {
  var _ref$isPhyAttImproved = _ref.isPhyAttImproved,
      isPhyAttImproved = _ref$isPhyAttImproved === void 0 ? false : _ref$isPhyAttImproved,
      _ref$isPhyDefImproved = _ref.isPhyDefImproved,
      isPhyDefImproved = _ref$isPhyDefImproved === void 0 ? false : _ref$isPhyDefImproved,
      _ref$isMagAttImproved = _ref.isMagAttImproved,
      isMagAttImproved = _ref$isMagAttImproved === void 0 ? false : _ref$isMagAttImproved,
      _ref$isMagDefImproved = _ref.isMagDefImproved,
      isMagDefImproved = _ref$isMagDefImproved === void 0 ? false : _ref$isMagDefImproved,
      offense = _ref.offense,
      defense = _ref.defense;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _CharacterStatsWindowModule.default.attAndDef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CharacterStatsWindowModule.default.phyAtt, _CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.phyAtt)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CharacterStatsWindowModule.default.phyAtt, _CharacterStatsWindowModule.default.value, isPhyAttImproved && _CharacterStatsWindowModule.default.isImproved)
  }, offense.physicalMin, " - ", offense.physicalMax), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CharacterStatsWindowModule.default.phyDef, _CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.phyDef)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CharacterStatsWindowModule.default.phyDef, _CharacterStatsWindowModule.default.value, isPhyDefImproved && _CharacterStatsWindowModule.default.isImproved)
  }, defense.physical), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CharacterStatsWindowModule.default.magAtt, _CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.magAtt)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CharacterStatsWindowModule.default.magAtt, _CharacterStatsWindowModule.default.value, isMagAttImproved && _CharacterStatsWindowModule.default.isImproved)
  }, offense.magicalMin, " - ", offense.magicalMax), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CharacterStatsWindowModule.default.magDef, _CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.magDef)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CharacterStatsWindowModule.default.magDef, _CharacterStatsWindowModule.default.value, isMagDefImproved && _CharacterStatsWindowModule.default.isImproved)
  }, defense.magical));
}